export default __webpack_public_path__ + "static/media/image7.7e249353.png";